import React, { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import * as quoteApi from './quoteApi';
import SchematicViewer from './SchematicViewer';
import { SchematicMeta } from './quoteApi';

const SchematicPopout: React.FC = () => {
  const [params] = useSearchParams();
  const quoteId = params.get('quoteId') || '';
  const lineId = Number(params.get('lineId') || 0);
  const [meta, setMeta] = useState<SchematicMeta | null>(null);
  const [page, setPage] = useState<number | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!quoteId || !lineId) {
      setError('Missing quote or line for this schematic.');
      return;
    }
    quoteApi.getSchematicMeta(quoteId, lineId)
      .then((data) => {
        setMeta(data);
        setPage(data.pages[0] || data.all_pages?.[0] || 1);
      })
      .catch((err) => setError(err.response?.data?.detail || err.message || 'Schematic not available'));
  }, [quoteId, lineId]);

  return (
    <Box sx={{ p: 2, minHeight: '100vh', bgcolor: 'background.default' }}>
      <Typography variant="h6" sx={{ mb: 1 }}>Schematic</Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {!error && !meta && <CircularProgress size={24} />}
      {meta && (
        <SchematicViewer
          quoteId={quoteId}
          lineId={lineId}
          meta={meta}
          page={page}
          onPageChange={setPage}
          popout
        />
      )}
    </Box>
  );
};

export default SchematicPopout;
